import { css } from 'styled-components';

const utility = css`
  /* Datepicker */
  .ant-picker {
    background: ${({ theme }) => theme.colors.inputBackgoundColor};
    border: 1px solid ${({ theme }) => theme?.colors?.neutralGray2};
    padding: 12px 16px !important;
    border-radius: 0px;
    box-shadow: none !important;

    &:hover {
      animation-delay: 1s;
      animation-duration: 2s;
      border: 1px solid ${({ theme }) => theme.colors.primary} !important;
    }

    .ant-picker-active-bar {
      background-color: ${({ theme }) => theme.colors.primary};
    }
  }

  .ant-picker-dropdown {
    .ant-picker-cell {
      vertical-align: middle !important;
    }
    .ant-picker-cell-disabled::before {
      background: transparent !important;
    }
    .ant-picker-cell-disabled .ant-picker-cell-inner {
      background: rgba(0, 0, 0, 0.04) !important;
      border-radius: 4px !important;
    }
  }

  //editor
  .ql-container {
    background-color: ${({ theme }) => theme.colors.neutralWhite};
    border-radius: 0 0 6px 6px;
  }

  .ql-toolbar.ql-snow {
    border-radius: 6px 6px 0 0;
    min-height: 100px;
  }
  .ql-editor:before {
    line-height: 14px;
  }
  .ql-editor:before {
    line-height: 14px;
  }
  //form item
  .ant-form-item {
    margin: 0;
  }

  ///Pagination
  .ant-pagination {
    /* li {
      transition: all 0.3s;

      &:hover {
        border-color: ${({ theme }) => theme?.colors?.primaryColor};
        background-color: ${({ theme }) =>
      theme?.colors?.neutralWhite} !important;

        button {
          background-color: ${({ theme }) =>
      theme?.colors?.neutralWhite} !important;
          border-color: ${({ theme }) =>
      theme?.colors?.primaryColor} !important;
        }
      }

      &.ant-pagination-item {
        background-color: ${({ theme }) => theme?.colors?.neutralWhite};
        border: 1px solid ${({ theme }) => theme?.colors?. textColor};
        color: ${({ theme }) => theme?.colors?.textColor} !important;

        &:hover {
          background-color: ${({ theme }) => theme?.colors?.primaryColor};
          border-color: ${({ theme }) => theme?.colors?.primaryColor};
          color: ${({ theme }) => theme?.colors?.neutralWhite} !important;
        }
      }

      &.ant-pagination-item-active {
        font-weight: ${({ theme }) => theme?.fontWeight?.bold};
        background-color: ${({ theme }) =>
      theme?.colors?.primaryColor} !important;
        border-color: ${({ theme }) => theme?.colors?.primaryColor};
        color: ${({ theme }) => theme?.colors?.neutralWhite} !important;

        a {
          color: ${({ theme }) => theme?.colors?.neutralWhite} !important;
        }
      }

      .ant-pagination-options-size-changer {
        .ant-select-selector {
          border: 1px solid ${({ theme }) =>
      theme?.colors?.neutralGray3} !important;

          &:hover {
            border-color: ${({ theme }) =>
      theme?.colors?.primaryColor} !important;
          }
        }
      }
    } */
    li {
      margin-inline-end: 0px !important;
      border-color: transparent !important;
      color: ${({ theme }) => theme?.colors?.textColor} !important;
      transition: all 0.3s;

      a {
        color: ${({ theme }) => theme?.colors?.textColor} !important;
      }

      &.ant-pagination-item-active {
        color: ${({ theme }) => theme?.colors?.neutralWhite} !important;
        a {
          color: ${({ theme }) => theme?.colors?.neutralWhite} !important;
        }
      }

      button {
        svg {
          filter: invert(72%) sepia(13%) saturate(202%) hue-rotate(202deg)
            brightness(101%) contrast(84%);
        }
      }

      &:hover {
        background-color: ${({ theme }) =>
          theme?.colors?.cardBackground} !important;
        button {
          border-color: transparent !important;
        }
      }

      &.ant-pagination-item-active {
        background-color: #3e97ff !important;
      }

      .ant-pagination-options-size-changer .ant-select-selector {
        color: ${({ theme }) => theme?.colors?.textColorGray};
        border-color: ${({ theme }) => theme?.colors?.borderTable} !important;
      }

      .ant-select-arrow {
        svg {
          filter: invert(72%) sepia(13%) saturate(202%) hue-rotate(202deg)
            brightness(101%) contrast(84%);
        }
      }
    }

    .ant-select-selector {
      background: ${({ theme }) => theme?.colors?.cardBackground};
      background-color: ${({ theme }) =>
        theme?.colors?.cardBackground} !important;
    }

    /* .ant-select-dropdown {
      background: ${({ theme }) => theme?.colors?.buttonPrimary};
      background-color: ${({ theme }) => theme?.colors?.buttonPrimary};
    } */

    .ant-pagination-item-link {
      background-color: ${({ theme }) =>
        theme?.colors?.cardBackground} !important;
    }
  }

  .ant-modal .ant-modal-content {
    background: ${({ theme }) => theme?.colors?.modalBackground} !important;
  }

  .ant-table-wrapper .ant-table-cell-scrollbar:not([rowspan]) {
    box-shadow: none;
  }

  .ant-modal .ant-modal-header {
    background: ${({ theme }) => theme?.colors?.modalBackground} !important;
  }

  .ant-table-wrapper .ant-table-tbody > tr.ant-table-row-selected > td {
    background: ${({ theme }) => theme?.colors?.cardBackground} !important;
  }

  .ant-table-tbody > tr.ant-table-row:hover > td {
    background: ${({ theme }) => theme?.colors?.cardBackground} !important;
  }

  /// Menu
  .ant-menu-dark.ant-menu-submenu > .ant-menu {
    background-color: #2a2a3c;
    color: #ffffff;

    .ant-menu-item {
      display: flex;
      padding: 0 10px;
      margin: 0 !important;
      width: 100%;

      &:hover {
        background-color: #c1c1c1;
      }

      .ant-menu-title-content {
        width: 100%;
      }
    }
  }

  /// ~~~~~~~~~~~~~~~~~ margin style ~~~~~~~~~~~~~~~~~~~~~~~~~~
  /// margin style 15px
  .m-15t {
    margin: 15px;
  }

  .mt-15t {
    margin-top: 15px;
  }

  .mb-15t {
    margin-bottom: 15px;
  }

  .ml-15t {
    margin-left: 15px;
  }

  .mr-15t {
    margin-right: 15px;
  }

  /// margin style 10px
  .m-10t {
    margin: 10px;
  }

  .mt-10t {
    margin-top: 10px;
  }

  .mb-10t {
    margin-bottom: 10px;
  }

  .ml-10t {
    margin-left: 10px;
  }

  .mr-10t {
    margin-right: 10px;
  }

  /// margin style 5px
  .m-5t {
    margin: 5px;
  }

  .mt-5t {
    margin-top: 5px;
  }

  .mb-5t {
    margin-bottom: 5px;
  }

  .ml-5t {
    margin-left: 5px;
  }

  .mr-5t {
    margin-right: 5px;
  }

  /// ~~~~~~~~~~~~~~~~~ padding style ~~~~~~~~~~~~~~~~~~~~~~~~~~
  /// padding style 10px
  .p-10t {
    padding: 10px;
  }

  .pt-10t {
    padding-top: 10px;
  }

  .pb-10t {
    padding-bottom: 10px;
  }

  .pl-10t {
    padding-left: 10px;
  }

  .pr-10t {
    padding-right: 10px;
  }

  /// padding style 5px
  .p-5t {
    padding: 5px;
  }

  .pt-5t {
    padding-top: 5px;
  }

  .pb-5t {
    padding-bottom: 5px;
  }

  .pl-5t {
    padding-left: 5px;
  }

  .pr-5t {
    padding-right: 5px;
  }

  /// ~~~~~~~~~~~~~~~~~ text style ~~~~~~~~~~~~~~~~~~~~~~~~~~
  .text-centert {
    text-align: center;
  }

  .text-leftt {
    text-align: left;
  }

  .text-rightt {
    text-align: right;
  }
`;

export default utility;
